export const getBadPercent = (stats) => {
    let days = [];
    stats.forEach(stat => {
        days.push(stat.day)
    });
    let uniqueDays = [...new Set(days)]

    let percentAge = [];
    uniqueDays.forEach((uD) => {
        const uniqueDayStat = stats.filter((s) => s.day === uD)

        let totalBad = 0;
        let totalForWork = 0;
        uniqueDayStat.forEach((uDS) => {
            totalBad += uDS.badPieces
            totalForWork += uDS.forWork
        })
        percentAge.push(parseInt(parseInt(totalBad) / parseInt(totalForWork) * 100))

    })

    return { uniqueDays, percentAge }
}